import { render, staticRenderFns } from "./step_description_forestry_projects_rfrp.vue?vue&type=template&id=3b2762e7&scoped=true"
import script from "./step_description_forestry_projects_rfrp.vue?vue&type=script&lang=js"
export * from "./step_description_forestry_projects_rfrp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2762e7",
  null
  
)

export default component.exports